var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 1.75A4.25 4.25 0 0 1 16.25 6v1h2.237c.832 0 1.53.628 1.616 1.455l1.264 12c.1.96-.652 1.795-1.616 1.795H4.25a1.625 1.625 0 0 1-1.616-1.795l1.263-12A1.626 1.626 0 0 1 5.513 7H7.75V6A4.25 4.25 0 0 1 12 1.75M5.513 8a.626.626 0 0 0-.622.56l-1.262 12c-.04.368.25.69.62.69h15.502c.37 0 .66-.321.62-.69l-1.262-12a.625.625 0 0 0-.622-.56H16.25v1.782a.875.875 0 1 1-1 .001V8h-6.5v1.782a.875.875 0 1 1-1 .001V8zM12 2.75A3.25 3.25 0 0 0 8.75 6v1h6.5V6A3.25 3.25 0 0 0 12 2.75"
  })));
};
export default SvgShoppingBag;